module.exports = __webpack_public_path__ + "img/pre_right.1d0f19bb.png";